import { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import { All_University_Logo } from "../Model/UniversityModel";
import { useDispatch, useSelector } from "react-redux";
import {
  UniversityListRec,
  UniversityListUpdate,
} from "../actions/universityAction";
import { toast } from "react-toastify";
import { RECOMMENDED_UNIVERSITY_RESET } from "../constants/eventConstants";
import { toastOptions } from "../core/common";
import { useParams } from "react-router-dom";

export default function AddUniversity({ OpenNext, setOpenNext, ContactId }) {
  const [Country2, setCountry2] = useState([]);
    const { id } = useParams();
  const { loading, recommendRec, error } = useSelector(
    (s) => s.UniversityListRecReducer
  );
  const {
    loading: loadingUpt,
    success,
    error: errorUpt,
  } = useSelector((s) => s.UniversityListUpdateReducer);
  const dispatch = useDispatch();
  const handleCancel1 = () => {
    setOpenNext(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (ContactId) {
      dispatch(
        UniversityListUpdate(
          {
            recommendedCountry: [...Country2?.map((ev) => ev.value)],
            eventId: id || 125,
          },
          ContactId
        )
      );
    } else {
      toast.error("No Contact Found !", toastOptions);
    }
  };

  useEffect(() => {
    dispatch(UniversityListRec(ContactId));
  }, [dispatch, ContactId]);

  useEffect(() => {
    let act = {};
    for (let key in recommendRec) {
      if (
        key == "recommendedCountry" ||
        key == "preferredCountry" ||
        key == "heardFrom"
      ) {
        if (recommendRec[key] == "null" || recommendRec[key] == null) {
          act[key] = [];
        } else {
          let mlt = recommendRec[key]?.split(",");

          act[key] = [...mlt];
          if (key == "recommendedCountry") {
            let jkl = [];
            for (let i = 0; i < mlt?.length; i++) {
              let objk = All_University_Logo.find((ev) => ev?.Id == mlt[i]);

              jkl.push({ label: objk?.Name, value: objk?.Id });
            }

            setCountry2([...jkl]);
          }
        }
      }
    }
  }, [recommendRec]);

  useEffect(() => {
    if (success) {
      dispatch(UniversityListRec(ContactId));
      setOpenNext(false);
      toast.success("Recommended University Updated !", toastOptions);
      setTimeout(() => {
        dispatch({ type: RECOMMENDED_UNIVERSITY_RESET });
      }, 3000);
    }

    if (errorUpt) {
      toast.error(errorUpt, toastOptions);
    }
  }, [success, errorUpt]);

  return (
    <div
      id="CreatContact"
      className={OpenNext ? "overlay-note w-100" : "overlay-note"}
      style={{ top: "", zIndex: "100" }}
    >
      <div className="overlay-note-content mblVwe">
        <div className="note-title">
          <h4 className="text-left text-white pl-3">
            Add Recommended University
          </h4>
          <div className="closebtn">
            <a
              className="text-right text-white"
              onClick={() => handleCancel1(false)}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
        {loading ? (
          <h4>Loading...</h4>
        ) : (
          <div style={{ padding: "20px" }} id="noteBody">
            <div>
              <div style={{ width: "100%" }}>
                <div className="bg-light  mt-2">
                  <div style={{ color: "blue" }}>Recommended University</div>
                  <div style={{ width: "100%" }} className="form-group mt-2">
                    <MultiSelect
                      options={
                        All_University_Logo
                          ? All_University_Logo?.map((el) => {
                              return {
                                label: el.Name,
                                value: el.Id,
                              };
                            })
                          : []
                      }
                      className="Multi_Selector"
                      value={Country2}
                      onChange={(e) => setCountry2(e)}
                      labelledBy="Select"
                    />
                  </div>{" "}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    padding: "10px 0",
                    flexWrap: "wrap",
                  }}
                >
                  {Country2?.map((ev) =>
                    All_University_Logo?.find((eb) => eb.Id == ev?.value)
                      ?.Logo134x64 ? (
                      <div>
                        <img
                          style={{ width: "80%" }}
                          src={
                            All_University_Logo?.find(
                              (eb) => eb.Id == ev?.value
                            )?.Logo134x64
                          }
                        />
                      </div>
                    ) : All_University_Logo?.find((eb) => eb.Id == ev?.value)
                        ?.Logo50x50 ? (
                      <div>
                        <img
                          style={{ width: "70%" }}
                          src={
                            All_University_Logo?.find(
                              (eb) => eb.Id == ev?.value
                            )?.Logo50x50
                          }
                        />
                      </div>
                    ) : All_University_Logo?.find((eb) => eb.Id == ev?.value)
                        ?.Logo310x125 ? (
                      <div>
                        <img
                          style={{ width: "60%" }}
                          src={
                            All_University_Logo?.find(
                              (eb) => eb.Id == ev?.value
                            )?.Logo310x125
                          }
                        />
                      </div>
                    ) : (
                      ev?.label
                    )
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <button
                  className="cst_btn"
                  disabled={loadingUpt}
                  onClick={(e) => handleSubmit(e)}
                >
                  {loadingUpt ? "Loading..." : "Submit"}
                </button>{" "}
                <button
                  className="cst_btn"
                  disabled={loadingUpt}
                  onClick={() => handleCancel1()}
                >
                  Cancel
                </button>{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
